






































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { FontFamily } from "../../types";

const Customization = namespace("customization");

@Component({})
export default class Congratulations extends Vue {
  @Customization.Getter("getFontFamily") fontFamily: FontFamily;
}
